import CryptoJS from "crypto-js";

import { SALT } from "@/constants";

export default {
  token: state => state.token,
  passwordResetData: state => state.passwordResetData,
  group: state => {
    return state.group
      ? Number(
          CryptoJS.AES.decrypt(state.group, SALT).toString(CryptoJS.enc.Utf8)
        )
      : null;
  },
  name: state => {
    return state.name
      ? CryptoJS.AES.decrypt(state.name, SALT).toString(CryptoJS.enc.Utf8)
      : null;
  },
  id: state => {
    return state.id
      ? CryptoJS.AES.decrypt(state.id, SALT).toString(CryptoJS.enc.Utf8)
      : null;
  },
  user: state => {
    return {
      token: state.token,
      group: state.group,
      name: state.name,
      id: state.id
    };
  },
  authenticated: state => state.authenticated
};
